<template>
  <div id="frontCarousel" class="carousel header-carousel slide carousel-fade" data-bs-ride="Carousel" data-bs-interval="2000">
    <ol class="carousel-indicators">
      <template v-for="(ct, key) in content">
        <button type="button" data-bs-target="#frontCarousel" :data-bs-slide-to="key" :class="{ active: key === 0 }" :key="key" aria-current="true"></button>
      </template>
    </ol>
    <div class="carousel-inner">
      <template v-for="(ct, key) in content">
        <div class="carousel-item" :class="{ active: key === 0 }" :key="key">
          <div class="hero-image" :style="`background-image: url('${ct.imgUrl}')`">
           <div class="overlay">
            <div class="hero-text">
              <hgroup>
                <h1>{{ ct.contentTitle }}</h1>
                <h3>{{ ct.contentText }}</h3>
              </hgroup>
            </div>
          </div>
         </div>
        </div>
      </template>
    </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#frontCarousel" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#frontCarousel" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
  </div>
</template>

<script>
export default {
  name: "Maincarousel",

  data: () => ({
    content: [
      {
        imgUrl: "/img/creativeimage.png",
        contentTitle: "We are creative",
        contentText: "Get start your next awesome project",
      },
      {
        imgUrl: "/img/warehouse1x2.png",
        contentTitle: "We are Profesional",
        contentText: "Get start your next awesome project",
      },
      {
        imgUrl: "/img/dedicatedimage.png",
        contentTitle: "We are dedicated",
        contentText: "Get start your next awesome project",
      },
    ],
  }),
};
</script>

<style>

.header-carousel {
    margin-right: -15px;
    margin-left: -15px;
}
#frontCarousel .hero-image {
  background: black;
  background-repeat: no-repeat;
  background-position: center top;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  border-image-width: 0%;
  height: 100vh;
}

#frontCarousel .hero-text {
  position: absolute !important;
  top: 50%;
  left: 50%;
  z-index: 2;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.75);
  -webkit-transform: translate3d(-50%, -50%, 0);
  -moz-transform: translate3d(-50%, -50%, 0);
  -ms-transform: translate3d(-50%, -50%, 0);
  -o-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
}

#frontCarousel .hero-text h1 {
  font-size: 6em;
  font-weight: bold;
  margin: 0;
  padding: 0;
}

#frontCarousel .overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: #080d15;
  opacity: 0.7;
}

@media screen and (min-width: 640px) {
  .hero-text {
    width: 980px;
  }
}
@media screen and (max-width: 640px) {
  #frontCarousel .hero-text h1 {
    font-size: 3em;
  }
}
@media screen and (max-width: 576px) {
  #frontCarousel .hero-text h1 {
    font-size: 3em;
  }
}
</style>
